// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import homeWeb from '../components/homeWeb.vue';
import chanping1 from '../components/chanping-1.vue';
import chanping2 from '../components/chanping-2.vue';
import chanping3 from '../components/chanping-3.vue';
import chanping4 from '../components/chanping-4.vue';
import jiejfa1 from '../components/jiejfa-1.vue';
import yijii2 from '../components/yijii-2.vue' 
import chengguan3 from '../components/chengguan-3.vue'
import jiaotong4 from '../components/jiaotong-4.vue'
import qiyeigl5 from '../components/qiyuegl-5.vue'
import severHtml from '../components/severHtml.vue'
import gywmHtml from '../components/gywmHtml.vue'

import homeWebMb from '../components/mobile/homeWeb.vue'
import chanping1Mb from '../components/mobile/chanping-1.vue'
import chanping2Mb from '../components/mobile/chanping-2.vue'
import chanping3Mb from '../components/mobile/chanping-3.vue'
import chanping4Mb from '../components/mobile/chanping-4.vue'
import jiejfa1Mb from '../components/mobile/jiejfa-1.vue'
import yijii2Mb from '../components/mobile/yijii-2.vue'
import chengguan3Mb from '../components/mobile/chengguan-3.vue'
import jiaotong4Mb from '../components/mobile/jiaotong-4.vue'
import qiyeigl5Mb from '../components/mobile/qiyuegl-5.vue'
import severHtmlMb from '../components/mobile/severHtml.vue'
import gywmHtmlMb from '../components/mobile/gywmHtml.vue'

function isMobileModern() {
  // 检测是否为触摸屏
  const isTouchScreen = navigator.maxTouchPoints > 1;
  
  // 检测是否为移动设备的User-Agent
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUA = /mobile|android|iphone|ipad|ipod/i.test(userAgent);
  
  // 检测屏幕尺寸
  const isSmallViewport = window.innerWidth < 768;
  
  return isTouchScreen || isMobileUA || isSmallViewport;
}


const routes = [
  {
    path: '/',
    name: '上海谛视万象科技有限公司',
    component: homeWeb,
    beforeEnter: (to, from, next) => {
      if (isMobileModern()) {
        next('/mb/homeWebMb'); // 移动端跳转到移动端首页
      } else {
        next(); // 非移动端正常访问
      }
    }
  },
  {
    path: '/chanping1',
    name: 'chanping1',
    component: chanping1
  },
  {
    path: '/chanping2',
    name: 'chanping2',
    component: chanping2
  },
  {
    path: '/chanping3',
    name: 'chanping3',
    component: chanping3
  },
   {
    path: '/chanping4',
    name: 'chanping4',
    component: chanping4
  },
  {
    path: '/jiejfa1',
    name: 'jiejfa1',
    component: jiejfa1
  },
  {
    path: '/yijii2',
    name: 'yijii2',
    component: yijii2
  },
  {
    path: '/chengguan3',
    name: 'chengguan3',
    component: chengguan3
  },
  {
    path: '/jiaotong4',
    name: 'jiaotong4',
    component: jiaotong4
  },
  {
    path: '/qiyeigl5',
    name: 'qiyeigl5',
    component: qiyeigl5
  },
  {
    path: '/severHtml',
    name: 'severHtml',
    component: severHtml
  },
  {
    path: '/gywmHtml',
    name: 'gywmHtml',
    component: gywmHtml
  },
  // ------------------------------------
  {
    path: '/mb/homeWebMb',
    name: 'homeWebMb',
    component: homeWebMb,
    beforeEnter: (to, from, next) => {
      if (isMobileModern()) {
        next(); // 移动端跳转到移动端首页
      } else {
        next('/'); // 非移动端正常访问
      }
    }
  },
  {
    path: '/mb/chanping1Mb',
    name: 'chanping1Mb',
    component: chanping1Mb
  },
  {
    path: '/mb/chanping2Mb',
    name: 'chanping2Mb',
    component: chanping2Mb
  },
  {
    path: '/mb/chanping3Mb',
    name: 'chanping3Mb',
    component: chanping3Mb
  },
  {
    path: '/mb/chanping4Mb',
    name: 'chanping4Mb',
    component: chanping4Mb
  },
  {
    path: '/mb/jiejfa1Mb',
    name: 'jiejfa1Mb',
    component: jiejfa1Mb
  },
  {
    path: '/mb/yijii2Mb',
    name: 'yijii2Mb',
    component: yijii2Mb
  },
  {
    path: '/mb/chengguan3Mb',
    name: 'chengguan3Mb',
    component: chengguan3Mb
  },
  {
    path: '/mb/jiaotong4Mb',
    name: 'jiaotong4Mb',
    component: jiaotong4Mb
  },
  {
    path: '/mb/qiyeigl5Mb',
    name: 'qiyeigl5Mb',
    component: qiyeigl5Mb
  },
  {
    path: '/mb/severHtmlMb',
    name: 'severHtmlMb',
    component: severHtmlMb
  },
  {
    path: '/mb/gywmHtmlMb',
    name: 'gywmHtmlMb',
    component: gywmHtmlMb
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;